import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e113936"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<header class=\"bg-light col-12 fixed-top shadow-sm\" data-v-4e113936><nav class=\"px-3 px-md-0 col-12 col-md-9 m-auto navbar navbar-expand-md navbar-light bg-light\" data-v-4e113936><a class=\"navbar-brand\" href=\"/\" data-v-4e113936><img class=\"img-fluid py-1\" id=\"logo\" src=\"/img/logo.png\" data-v-4e113936></a><button class=\"navbar-toggler\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#navbarAdvance\" aria-controls=\"navbarAdvance\" aria-expanded=\"false\" aria-label=\"Toggle navigation\" data-v-4e113936><span class=\"navbar-toggler-icon\" data-v-4e113936></span></button><div class=\"collapse navbar-collapse\" id=\"navbarAdvance\" data-v-4e113936><ul class=\"navbar-nav ms-auto text-uppercase\" data-v-4e113936><li class=\"nav-item\" data-v-4e113936><a class=\"nav-link text-dark\" target=\"_blank\" href=\"https://www.getadvance.net\" data-v-4e113936>About Advance</a></li></ul></div></nav></header><div class=\"nav-placeholder\" data-v-4e113936></div>", 2)

import { useAuthStore } from "@/stores/auth";
import { useMiscStore } from "@/stores/misc";
import { useRoute } from "vue-router"
import { navigationData } from "@/data/navigation";
import { useMediaQuery } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavbarComponent',
  setup(__props) {

const authStore = useAuthStore();
const miscStore = useMiscStore();
const route = useRoute();
const isDesktop = useMediaQuery('(min-width: 992px)')

return (_ctx: any,_cache: any) => {
  return _hoisted_1
}
}

})